import React from "react";
import { Card } from "@/components/ui/card";
import { FileText, BarChart3 } from "lucide-react";
import { useTranslation } from 'react-i18next';

export default function LocationStats({ locationStats }) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4">
      <Card className="p-3 sm:p-4 bg-white border border-stone-200">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-blue-100 flex items-center justify-center">
            <FileText className="w-4 h-4 sm:w-5 sm:h-5 text-blue-700" />
          </div>
          <div>
            <p className="text-xl sm:text-2xl font-bold text-slate-900">{locationStats.total}</p>
            <p className="text-[10px] sm:text-xs text-slate-500">{t('locationReports.totalApplications')}</p>
          </div>
        </div>
      </Card>
      
      <Card className="p-3 sm:p-4 bg-white border border-stone-200">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-yellow-100 flex items-center justify-center">
            <BarChart3 className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-700" />
          </div>
          <div>
            <p className="text-xl sm:text-2xl font-bold text-slate-900">{locationStats.byStatus.submitted || 0}</p>
            <p className="text-[10px] sm:text-xs text-slate-500">{t('locationReports.pending')}</p>
          </div>
        </div>
      </Card>
      
      <Card className="p-3 sm:p-4 bg-white border border-stone-200">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
            <FileText className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-700" />
          </div>
          <div>
            <p className="text-xl sm:text-2xl font-bold text-slate-900">{locationStats.byStatus.approved || 0}</p>
            <p className="text-[10px] sm:text-xs text-slate-500">{t('locationReports.approved')}</p>
          </div>
        </div>
      </Card>
      
      <Card className="p-3 sm:p-4 bg-white border border-stone-200">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-red-100 flex items-center justify-center">
            <FileText className="w-4 h-4 sm:w-5 sm:h-5 text-red-700" />
          </div>
          <div>
            <p className="text-xl sm:text-2xl font-bold text-slate-900">{locationStats.byStatus.rejected || 0}</p>
            <p className="text-[10px] sm:text-xs text-slate-500">{t('locationReports.rejected')}</p>
          </div>
        </div>
      </Card>
    </div>
  );
}
